export default __webpack_public_path__ + "bf769084fde6c1835dec585f029e5648.svg";